import React from "react";
import { formatMoney, formatMoneySecondary } from "@/i18n";
import { useApp } from "@/context/AppContext";

/**
 * Renders a EUR value with the user's locale-formatted primary line and an
 * optional secondary approximate line (ILS/RUB) for Hebrew and Russian users.
 * The secondary line stays intentionally small and marked with "≈" so nobody
 * mistakes it for the settlement currency.
 */
export default function Money({ value, className = "", secondaryClassName = "text-xs text-[#8A7A5E] font-normal", "data-testid": testid = "money" }) {
  const { lang } = useApp();
  if (value === null || value === undefined || value === "") {
    return <span className={className}>—</span>;
  }
  const secondary = formatMoneySecondary(value, lang);
  return (
    <span className={className} data-testid={testid}>
      {formatMoney(value, lang)}
      {secondary && (
        <span className={`ms-2 ${secondaryClassName}`} data-testid={`${testid}-secondary`}>
          {secondary}
        </span>
      )}
    </span>
  );
}
